module.exports = __webpack_public_path__ + "static/media/vegitables_15.1fa3536a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_15.csv
// module id = 597
// module chunks = 0